import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import "./index.css";
import App from "./App";
import LandingPage from "@/features/landingPages/landing1";
import { NewsletterDashboard } from "@/features/newsletterSettings/components/NewsletterDashboard";
import { NewsletterForm } from "@/features/newsletterSettings/components/NewsletterForm";
import { FinishSetup } from "@/features/newsletterSettings/components/FinishSetup";
import NewsToday from "@/features/newsToday";
import { AuthPage } from "@/auth/AuthPage";
import NeoBrutalistHeatMap from "@/features/search/components/NeoBrutalistHeatMap";
import { RootRedirect } from "@/components/RootRedirect";
import { ArticleSearch } from "@/features/search/components/ArticleSearch";
const router = createBrowserRouter([
  {
    path: "/",
    element: <RootRedirect />,
  },
  {
    path: "/landing",
    element: <LandingPage />,
  },
  {
    path: "/dashboard",
    element: <App />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard/newsletter" replace />,
      },
      {
        path: "newsletter",
        element: <NewsletterDashboard />,
        children: [
          {
            path: "setup",
            element: <FinishSetup />,
          },
          {
            path: "edit",
            element: <NewsletterForm />,
          },
        ],
      },
      {
        path: "news-today",
        element: <NeoBrutalistHeatMap />,
      },
      {
        path: "search",
        element: <ArticleSearch />,
      },
    ],
  },
  {
    path: "/today",
    element: <NewsToday />,
  },
  {
    path: "/login",
    element: <AuthPage />,
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
